<template>
  <section
    class="f-col items-center b b-grey-50 px-4 py-6 ~md:flex-row"
    data-test-id="review-snapshot-average-reviews"
    style="justify-content: space-around"
  >
    <div
      v-if="ratio > recommendationRateThreshold"
      class="text-center <md:mb-4"
      data-test-id="review-snapshot-customer-recommended"
    >
      <p class="display-3">
        {{ ratio }}%
      </p>
      <p>{{ $t.customerRecommended }}</p>
    </div>
    <div class="text-center">
      <p v-if="averageRating" class="display-3">
        {{ averageRating }}
      </p>
      <vf-rating v-if="averageRating" class="mb-2" :value="averageRating" />
      <base-button
        v-if="reviewsCount"
        class="cursor-pointer underlined"
        @click="$emit('scroll-to-reviews')"
      >
        {{ replaceAll($pluralize($t.numberOfReviews, reviewsCount), { reviewsCount }) }}
      </base-button>
    </div>
  </section>
</template>

<script lang="ts" setup>
defineProps<{
  averageRating: number
  ratio: number
  recommendationRateThreshold: number
  reviewsCount: number
}>()

defineEmits<{
  'scroll-to-reviews': []
}>()
</script>
